import { render, staticRenderFns } from "./ContabilitaDocumentoRigaAggiungiArticoloBoxComponent.vue?vue&type=template&id=68afbf77&scoped=true"
import script from "./ContabilitaDocumentoRigaAggiungiArticoloBoxComponent.vue?vue&type=script&lang=js"
export * from "./ContabilitaDocumentoRigaAggiungiArticoloBoxComponent.vue?vue&type=script&lang=js"
import style0 from "./ContabilitaDocumentoRigaAggiungiArticoloBoxComponent.vue?vue&type=style&index=0&id=68afbf77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68afbf77",
  null
  
)

export default component.exports